import {Component, OnInit, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { GlobalServiceService } from './global-service.service';



@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.css']
})
export class MainHeaderComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.43;
  carouserSpeed: number = 4000;
  static isStarted: boolean = false;
  currentSlideNumber: number = 1;

  constructor(private service: GlobalServiceService) {
  }

  ngOnInit() {
    this.onResize();
    if (!MainHeaderComponent.isStarted){
    this.carousel();
      MainHeaderComponent.isStarted = true;
      MainHeaderComponent.setCurrentSlideMark(this.currentSlideNumber);
    } else {
      $('.slide').hide();
      $('.slide').first().addClass("active");
      $('.active').show();
      MainHeaderComponent.setCurrentSlideMark(this.currentSlideNumber);
    }
  }



  onResize() {
    this.calculateAdaptiveHeight();
    this.height = this.service.getHeight(this.proportion);

    let width =  $(window).width();
    $('#circle').css('r', width / 250);
  }

  calculateAdaptiveHeight(){
    let width = $(window).width();
    let adaptedWidth;
    if (width >= 1600) {
      adaptedWidth = width;
    } else if (width < 1600 && width >= 1300) {
      adaptedWidth = width * 1.13;
    } else if (width < 1300 && width >= 785){
      adaptedWidth = width * 1.3;
    } else {
      adaptedWidth = width * 1.5;
    }

    if (width < $(window).height()){
    }

    this.service.setWidth(adaptedWidth);
  }



  carousel() {
    const speed = 1200;
    let autoswitch = true;
    const autoswitch_speed = 10000;
    let slideNumber = 1;

    $('.slide').hide();
    $('.slide').first().addClass("active");
    $('.active').show();
    let interval = setInterval(function () {
      if (autoswitch == true) {
        $('.active').removeClass('active').addClass('oldActive');
        if ($('.oldActive').is(":last-child")) {
          $(".slide").first().addClass("active");
          $('.item').css('opacity', '1');
          slideNumber = 1;
        } else {
          $(".oldActive").next().addClass("active");
          slideNumber++;
          // alert(this.currentSlideNumber);
        }
        $(".oldActive").removeClass("oldActive");
        $(".slide").fadeOut(speed);
        $(".active").fadeIn(speed);
        MainHeaderComponent.setCurrentSlideMark(slideNumber);
        // console.log(slideNumber);

      }
    }, autoswitch_speed);
  };

  static setCurrentSlideMark(slideNumber: number) {
    $('.itemActive ').removeClass('itemActive ');
    let item = $('.item' + slideNumber);
    item.addClass('itemActive');
  }
}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/main-header.component.ts